export default __webpack_public_path__ + "static/stemeditor_screenshot-bda5baafb73598df9a13b93e0bd053c4.jpg";